import { CheckoutAbTestMetricToOptimize } from "@redotech/redo-model/checkouts/checkout-ab-test-builder";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

const upcomingSplitInfoSchema = z.object({
  _id: zExt.objectId(),
  name: z.string(),
  description: z.string(),
  createdAt: z.date(),
  metricToOptimize: createEnum(CheckoutAbTestMetricToOptimize),
});

export const getUpcomingCheckoutSplitsInOrder = {
  name: "getUpcomingCheckoutSplitsInOrder" as const,
  input: z.null(),
  output: z.object({ upcomingSplits: z.array(upcomingSplitInfoSchema) }),
};
export type GetUpcomingCheckoutSplitsInOrderOutput = z.infer<
  typeof getUpcomingCheckoutSplitsInOrder.output
>;
